import MutateQrCode from "./MutateQrCode";

export default MutateQrCode